<div class="sticky-top">
    <nav
        class="text-bg-primary py-0 search-lang-nav"
        id="search-lang-nav"
        aria-label="Navigation"
    >
        <div class="d-flex inner-search-nav">
            <div
                class="language-selector ms-auto my-auto me-1 me-sm-3 align-self-center"
            >
                <vision2-language-selector></vision2-language-selector>
            </div>
            <div class="navbar_search my-auto me-3 d-none d-lg-block">
                <div class="navbar_search-form">
                    <form
                        (onSubmit)="search(searchText)"
                        class="form-inline mb-0"
                        role="search"
                    >
                        <div class="input-group">
                            <input
                                [placeholder]="
                                    'NAVIGATION_SEARCH-INPUT_PLACEHOLDER_TEXT'
                                        | translate
                                "
                                (keyup.enter)="search(searchText)"
                                (focus)="scriptLoader.loadGoogleSearch()"
                                [(ngModel)]="searchText"
                                [ngModelOptions]="{ standalone: true }"
                                class="form-control"
                                id="searchResults"
                                type="text"
                            />

                            <span class="input-group-text" id="search">
                                <div
                                    (click)="search(searchText)"
                                    (keydown.enter)="search(searchText)"
                                    (keydown.space)="
                                        search(searchText);
                                        $event.preventDefault()
                                    "
                                    role="button"
                                    tabindex="0"
                                >
                                    <img
                                        [src]="
                                            'NAVIGATION_SEARCH-INPUT_SEARCH-ICON_URL'
                                                | translate
                                        "
                                        [alt]="
                                            'NAVIGATION_SEARCH-INPUT_SEARCH-ICON_ALT_TEXT'
                                                | translate
                                        "
                                        class="img-fluid"
                                    />
                                </div>
                            </span>
                        </div>
                    </form>
                </div>
            </div>

            <div
                class="navbar_search--mobile my-auto me-1 me-sm-3 d-block d-lg-none"
            >
                <button
                    (click)="toggleSearch()"
                    [ngClass]="{ active: searchInput }"
                    class="btn-search-toggle btn p-0"
                    role="button"
                    id="search-toggle"
                >
                    <img
                        [src]="'NAVIGATION_SEARCH-TOGGLE_ICON_URL' | translate"
                        [alt]="
                            'NAVIGATION_SEARCH-TOGGLE_ICON_ALT_TEXT' | translate
                        "
                        class="img-fluid"
                    />
                </button>

                @if (searchInput) {
                <div class="navbar_search-form">
                    <form
                        (onSubmit)="search(searchText)"
                        class="form-inline mb-0"
                        role="search"
                    >
                        <div class="input-group">
                            <input
                                [placeholder]="
                                    'NAVIGATION_SEARCH-INPUT_PLACEHOLDER_TEXT'
                                        | translate
                                "
                                (keyup.enter)="search(searchText)"
                                (focus)="scriptLoader.loadGoogleSearch()"
                                [(ngModel)]="searchText"
                                [ngModelOptions]="{ standalone: true }"
                                class="form-control"
                                id="searchResults"
                                type="text"
                            />

                            <span class="input-group-text" id="search">
                                <div
                                    (click)="toggleSearch()"
                                    (keydown.enter)="toggleSearch()"
                                    (keydown.space)="
                                        toggleSearch(); $event.preventDefault()
                                    "
                                    role="button"
                                    tabindex="0"
                                >
                                    <img
                                        [src]="
                                            'NAVIGATION_SEARCH-INPUT_SEARCH-CLOSE-ICON_URL'
                                                | translate
                                        "
                                        [alt]="
                                            'NAVIGATION_SEARCH-INPUT_SEARCH-CLOSE-ICON_ALT_TEXT'
                                                | translate
                                        "
                                        class="img-fluid"
                                    />
                                </div>
                            </span>
                        </div>
                    </form>
                </div>
                }
            </div>
        </div>
    </nav>
    <nav
        class="navbar navbar-expand-lg bg-gray-20 py-0 position-relative d-flex flex-nowrap"
    >
        <a
            class="navbar-brand col-auto ms-2 ms-md-4 ms-lg-5 ms-xl-6"
            [brandHref]="'NAVIGATION_VISION-LOGO_IMAGE_LINK_URL' | translate"
        >
            <img
                class="d-none d-lg-block"
                [src]="'NAVIGATION_VISION-LOGO_IMAGE_URL' | translate"
                [alt]="'NAVIGATION_VISION-LOGO_IMAGE_ALT_TEXT' | translate"
            />

            <img
                class="d-block d-lg-none"
                [src]="'NAVIGATION_LAPTOP_VISION-LOGO_IMAGE_URL' | translate"
                [alt]="'NAVIGATION_VISION-LOGO_IMAGE_ALT_TEXT' | translate"
            />
        </a>

        <!-- mobile nav -->
        <div
            #mobileNav
            class="d-flex flex-row-reverse d-lg-none container"
            id="mobileNav"
        >
            <button
                class="btn"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvas"
                aria-controls="offcanvas"
                [attr.aria-label]="
                    'NAVIGATION_VISION-MENU-TOGGLER_ALT_TEXT' | translate
                "
            >
                <span class="navbar-toggler-icon"></span>
            </button>
        </div>

        <!-- desktop navbar -->
        @let navData = componentData$ | async; @if (navData && isReady) {
        <div
            #topNav
            class="collapse navbar-collapse navbar-nav-scroll d-none d-lg-block"
            id="topNav"
        >
            <ul class="navbar-nav mx-auto justify-content-center">
                @for(topNavItem of navData; track topNavItem; let i = $index) {
                @if(topNavItem['has-dropdown'] === 'Yes') {
                <li
                    [ngClass]="
                        activeDropdown[i] === true ? 'active dropup' : ' '
                    "
                    class="nav-item dropdown position-static mx-2"
                >
                    <button
                        (click)="onClickDropdown(i)"
                        class="nav-link d-flex align-items-center h-100 py-1 pr-2 dropdown-toggle"
                        [id]="topNavItem.title"
                    >
                        <span
                            [innerHtml]="
                                topNavItem['title-translated'] ||
                                topNavItem.title
                            "
                        ></span>
                    </button>
                    <div
                        [ngClass]="activeDropdown[i] === true ? 'show ' : ' '"
                        [class]="
                            'dropdown-menu py-0 rounded-bottom-4 ' +
                            topNavItem['dropdown-id']
                        "
                        [attr.aria-labelledby]="topNavItem.title"
                    >
                        <div class="bg-white pt-4 pb-4 px-3 rounded-bottom-4">
                            <!-- dropdowns -->
                            @if (topNavItem['has-dropdown'] === 'Yes') {
                            <div class="d-flex justify-content-start">
                                @if (topNavItem['featured-link-url']) { @let
                                topNavFeaturedLink =
                                topNavItem['featured-link-url'];
                                <div class="pb-2 lead featured-link">
                                    <a
                                        (click)="closeCollapse()"
                                        [brandHref]="topNavFeaturedLink"
                                        class="icon-link"
                                    >
                                        <div
                                            [innerHTML]="
                                                topNavItem['featured-link-text']
                                            "
                                        ></div>
                                        <span>
                                            <img
                                                class="align-baseline"
                                                [src]="
                                                    'GLOBAL_ARROW-RIGHT_ICON_URL'
                                                        | translate
                                                "
                                                [alt]="
                                                    'GLOBAL_ARROW-RIGHT_ICON_ALT_TEXT'
                                                        | translate
                                                "
                                            />
                                        </span>
                                    </a>
                                </div>
                                }
                            </div>

                            <div class="d-flex justify-content-start">
                                @for(column of topNavItemColumns[i] || []; track
                                column; let columnIndex = $index; let first =
                                $first; let last = $last) {
                                <div
                                    class="nav-column"
                                    [ngClass]="{
                                            'pe-2': !last,
                                        }"
                                >
                                    @for(columnItems of topNavItem.navItems;
                                    track columnItems;) { @if
                                    (columnItems['column'] === column) { @if
                                    (columnItems.type === 'Heading') {
                                    <div class="heading text-gray-90">
                                        @if (columnItems['link-url']) {
                                        <a
                                            (click)="closeCollapse()"
                                            [innerHtml]="
                                                columnItems[
                                                    'title-translated'
                                                ] || columnItems.title
                                            "
                                            [brandHref]="
                                                columnItems['link-url']
                                            "
                                            class="text-gray-90"
                                        ></a>
                                        } @else {
                                        <p
                                            [innerHtml]="
                                                columnItems[
                                                    'title-translated'
                                                ] || columnItems.title
                                            "
                                            class="text-gray-90 mb-0"
                                        ></p>
                                        }
                                    </div>
                                    } @if (columnItems.type === 'Sub-heading') {
                                    <div
                                        class="sub-heading text-navy-blue pt-1"
                                    >
                                        @if (columnItems['link-url']) {
                                        <a
                                            (click)="closeCollapse()"
                                            [innerHtml]="
                                                columnItems[
                                                    'title-translated'
                                                ] || columnItems.title
                                            "
                                            [brandHref]="
                                                columnItems['link-url']
                                            "
                                            class="text-navy-blue"
                                        ></a>
                                        } @else {
                                        <p
                                            [innerHtml]="
                                                columnItems[
                                                    'title-translated'
                                                ] || columnItems.title
                                            "
                                            class="text-navy-blue mb-0"
                                        ></p>
                                        }
                                    </div>
                                    } @if (columnItems.type === 'Page') {
                                    <div class="product-link pt-1">
                                        <a
                                            (click)="closeCollapse()"
                                            [innerHtml]="
                                                columnItems[
                                                    'title-translated'
                                                ] || columnItems.title
                                            "
                                            [brandHref]="
                                                columnItems['link-url']
                                            "
                                            class="text-gray-80"
                                        ></a>
                                    </div>
                                    } } }
                                </div>
                                }
                            </div>
                            }
                        </div>
                    </div>
                </li>
                } @else if(topNavItem['has-dropdown'] === 'No') {
                <li class="nav-item mx-2">
                    @if (topNavItem.link) {
                    <a
                        [brandHref]="topNavItem.link"
                        (click)="closeCollapse()"
                        class="nav-link d-flex align-items-center h-100 py-1"
                    >
                        <span
                            [innerHtml]="
                                topNavItem['title-translated'] ||
                                topNavItem.title
                            "
                        ></span>
                    </a>
                    } @else {
                    <button
                        (click)="closeCollapse()"
                        class="nav-link d-flex align-items-center h-100 py-1"
                    >
                        <span
                            [innerHtml]="
                                topNavItem['title-translated'] ||
                                topNavItem.title
                            "
                        ></span>
                    </button>
                    }
                </li>
                } }
            </ul>
        </div>
        }
    </nav>
</div>

<div
    #navPanel
    class="offcanvas-lg offcanvas-end bg-light"
    tabindex="-1"
    id="offcanvas"
    data-bs-scroll="false"
>
    @if (navData && navData.length && isReady) {
    <vision2-navigation-mobile [navData]="navData"></vision2-navigation-mobile>
    }
</div>
